

const achievements = [
  ["😱", "Extrovert", 0, 0],
  ["😐", "Vibe killer", 0, 1],
  ["😸", "Pussy expert", 0, 2],
  ["👯‍♀️", "Doppelgänger", 0, 3],
  ["🙅‍♂️", "Way off track", 0, 4],
  ["💦", "Impress professor", 0, 5],
  ["✍️", "Helper", 0, 6],
  ["🫰", "Real friend", 0, 7],
  ["🕵️", "Oops, Sherlock", 0, 8],
  ["🦪", "Accio clitoris", 0, 9],
  ["🍒", "Boob guy", 0, 10],
  ["🍑", "Butt guy", 0, 11],
  ["🗡️", "Sir Camelot", 0, 12],
  ["🤓", "Remaining knowledge", 0, 13],
  ["🏊", "The WETs", 0, 14],
  ["💤", "Wet dreams", 0, 15, 3],
  ["⛑️", "Step into the rescue", 0, 16],
  ["💭", "Dreamer", 0, 17],
  ["💞", "Comforter", 0, 18],
  ["🤿", "Deep into the process", 0, 19],
  ["🦸", "Homework hero", 0, 20],
  ["👅", "Skilled tongue", 0, 21, 20],
];

export default achievements;
